import { PageContainer, PageHeader, Spread, VStack } from '@/components/Atoms'
import { Card, CardContent } from '@/components/Card'
import { useDefaultTerritories, useQueryDefaults } from '@/hooks/queries/defaults/useQueryDefaults'
import { bannerSearchSchema } from '@/hooks/queries/useBanners'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import BannerDataTable from './-components/BannerDataTable'

export const Route = createFileRoute('/_auth/_modules/_app/customers/banners/')({
  component: Banners,
  validateSearch: (search) => bannerSearchSchema.parse(search),
})

function Banners() {
  const { t } = useTranslation('banners')
  const navigate = Route.useNavigate()
  const search = Route.useSearch()

  const defaultTerritories = useDefaultTerritories()

  useQueryDefaults({
    search,
    navigate,
    defaults: { territory: defaultTerritories },
  })

  return (
    <PageContainer>
      <Spread>
        <PageHeader>{t('bannersPage.header')}</PageHeader>
      </Spread>

      <Card>
        <CardContent className="py-6">
          <VStack gap="md">
            <BannerDataTable />
          </VStack>
        </CardContent>
      </Card>
    </PageContainer>
  )
}
